<template>
    <section class="race-card container my-4 shadow-sm">
        <div class="row align-items-center g-0 race-row">

            <div class="col-lg-2 col-md-12 text-center py-3">
                <img :src="banner" alt="Carrera" class="race-image" />
            </div>

            <div class="col-lg-3 col-md-12 race-block with-divider text-center text-lg-start px-4">
                <h3 class="race-title fw-black mb-1" v-html="titulo || ''"></h3>
                <p class="race-location mb-0 text-uppercase small letter-spacing-2" :style="{ color: colorEstado }">
                    {{ estado }}
                </p>
            </div>

            <div class="col-lg-4 col-md-12 race-block with-divider px-4 py-3 py-lg-0">
                <div class="race-info-grid">
                    <p class="mb-1"><strong> Fecha:</strong> {{ fecha }}</p>
                    <p class="mb-1"><strong> Sede:</strong> {{ sede }}</p>
                    <p class="mb-1"><strong> Hora:</strong> {{ hora }}</p>
                    <p class="mb-1"><strong> Distancia:</strong> <span class="badge bg-dark">{{ distancia }}</span></p>
                </div>
            </div>

            <div class="col-lg-3 col-md-12 text-center px-4 mb-4 mb-lg-4">
                <button class="btn-register w-100 shadow-sm" @click="actionClick" :disabled="inscripcionCerrada">
                    {{ inscripcionCerrada ? 'REGISTRO FINALIZADO' : textoBoton }}
                </button>
            </div>

        </div>
    </section>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      default: ''
    },
    estado: {
      type: String,
      default: ''
    },
    colorEstado: {
      type: String,
      default: '#000'
    },
    fecha: {
      type: String,
      default: ''
    },
    sede: {
      type: String,
      default: ''
    },
    hora: {
      type: String,
      default: ''
    },
    distancia: {
      type: String,
      default: ''
    },
    banner: {
      type: String,
      default: ''
    },
    textoBoton: {
      type: String,
      default: 'Inscribirme'
    },
    actionClick: {
      type: Function,
      default: () => {}
    },
    inscripcionCerrada: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.race-card {
  background-color: #ffffff;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid #eee;
  transition: transform 0.3s ease;
}

.race-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0,0,0,0.1) !important;
}

.logo-wrapper {
  width: 100px;
  height: 100px;
  background: #000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.race-image {
  width: 100%;
  max-width: 120px;
  border-radius: 14px;
}

.race-block {
  position: relative;
}

/* Divisor negro estilo banner */
.with-divider::after {
  content: '';
  position: absolute;
  top: 20%;
  right: 0;
  width: 2px;
  height: 60%;
  background-color: #000; /* Negro sólido */
}

.race-title {
  font-family: 'Inter', sans-serif;
  font-weight: 900; /* Extra bold */
  font-size: 1.4rem;
  color: #000;
  text-transform: uppercase;
  line-height: 1.1;
}

.letter-spacing-2 {
    letter-spacing: 2px;
}

.race-info-grid p {
    font-size: 0.9rem;
    color: #444;
}

.btn-register {
  background-color: #000;
  color: #ffffff;
  padding: 18px 20px;
  border-radius: 14px;
  font-weight: 900;
  border: none;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s ease;
}

.btn-register:hover {
  background-color: #222;
  letter-spacing: 2px;
}

/* Responsive */
@media (max-width: 991px) {
  .with-divider::after { display: none; }
  .race-block { border-bottom: 1px solid #eee; padding-bottom: 15px; margin-bottom: 15px; }
  .race-block:last-of-type { border-bottom: none; }
}
</style>
